<script>
  import ChangePwd from "../components/ChangePwd.svelte";
  import Registration from "../components/Registration.svelte";

  let token = window.token;

  export let flow;
  export let config;
</script>

{#if flow === "recover"}
  <ChangePwd {token} {config} />
{:else}
  <Registration {token} {config} />
{/if}
